// Types
// Components
import type React from 'react';
import type { TDynamicAvailability } from '@timeedit/types/lib/types';
import GeneralInfo from './GeneralInfo';
import ObjectCriteriaSection from './ObjectCriteriaSection';
import Properties from './Properties';
// Styles
import './DynamicAvailability.scss';

interface Props {
  dynamicAvailability?: TDynamicAvailability;
  onChange: (updatedValues: Record<string, any>) => void;
  isExpand: boolean;
}

const DynamicAvailability: React.FC<Props> = ({
  dynamicAvailability,
  onChange,
  isExpand,
}) => {
  return (
    <div className="dynamic-availability">
      <GeneralInfo
        dynamicAvailability={dynamicAvailability}
        onChange={onChange}
      />
      <Properties
        dynamicAvailability={dynamicAvailability}
        onChange={onChange}
      />
      <ObjectCriteriaSection
        dynamicAvailability={dynamicAvailability}
        onChange={onChange}
        isExpand={isExpand}
      />
    </div>
  );
};

export default DynamicAvailability;
